import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "./Transitforminner.scss";
import { RiDeleteBin6Line } from "react-icons/ri";
import AsyncSelect from "react-select/async";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getBasicInformation } from "../../api/actions/object";
import { useFormik } from "formik";
import {
  creatTransit,
  singleTransitDetails,
  transitApprove,
  withdrawPdf,
} from "../../api/actions/transitform";
import { listUserDropdown } from "../../api/actions/user";
import {
  ADMIN_DETAILS,
  lIST_NOTIFICATION,
  TRANSIT_FORM_LIST,
  TRNSIT_OBJECT_LIST,
} from "../../constants/routers";
import { GoArrowLeft } from "react-icons/go";
import Loader from "../../components/common/Common/Loader";
import toast from "react-hot-toast";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";
import * as Yup from "yup";
import { checkPermission } from "../../helpers/permissions";
import ImageEnlarge from "../../components/common/Common/imageEnlarge";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Transitforminner = ({
  mainImage,
  thumbnails,

  objectName,
  category,
  location,
}) => {
  const { id } = useParams();
  const locationNavigation = useLocation();
  const navigate = useNavigate();
  const transitSelectedDatas = locationNavigation?.state?.transitSelectedDatas;
  const fromTransitTable = locationNavigation?.state?.fromTransitTable;
  const fromNotificationHeader = locationNavigation?.state?.fromHeader;
  const fromview = locationNavigation?.state?.isView;
  const fromNotification = locationNavigation?.state?.fromNotification;
  const fromDetail = locationNavigation?.state?.fromDetail;
  const idFromDetail = locationNavigation?.state?.objectId;
  const transitRowData = locationNavigation?.state?.transitRowData;

  const userData = JSON.parse(localStorage.getItem("user_info"));
  const commonPath = userData.museum_name
    ? userData?.museum_name?.split(" ").join("_")
    : "Nefos";

  const [basicInformation, setBasicInformation] = useState([]);
  const [activeSlide, setActiveSlide] = useState(null);
  const [transitLoading, setTransitLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [receiverRemark, setRecieverRemark] = useState(null);
  const [recievedBy, setRecievedBy] = useState(false);
  const [createBy, setCreateBy] = useState(false);
  const [formStatus, setFormStatus] = useState(false);
  const [showImageEnlarge, setShowEnlargeImage] = useState({
    parentIndex: "",
    childIndex: "",
    imageIndex: "",
    imageIdTitle: "",
    image: "",
    show: false,
    title: "",
    isEdit: false,
  });
  const [recieverValidation, setRecieverValidation] = useState(false);
  const [selectedObject, setSelectedObject] = useState({
    image: "",
    name: "",
    category: "",
    location: "",
    accession_number: "",
    stability: "",
  });
  const [defaultUser, setDefaultUser] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [user, setUser] = useState([]);
  const [newValue, setNewValue] = useState("");
  const [collectionRepresentative, setCollectionRepresentative] = useState([]);
  const [defaultCollectionRepresantative, setDefaultCollectionRepresantative] =
    useState([]);
  const [collectionRepresentativeLoading, setCollectionRepresentativeLoading] =
    useState(false);
  const [conservationRepresentative, setConservationRepresentative] = useState(
    []
  );
  const [
    defaultConservationRepresentative,
    setDefaultConservationRepresentative,
  ] = useState([]);
  const [
    conservationRepresentativeLoading,
    setConservationRepresentativeLoading,
  ] = useState(false);

  const swiperRef = useRef(null);

  const transitObjectsIds = transitSelectedDatas?.objectIds?.map((li) => ({
    museum_object: li,
  }));

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      received_by: Yup.string().trim().required("Required"),
      collection_representative: Yup.string().trim().required("Required"),
      conservation_representative: Yup.string().trim().required("Required"),
    }),
    initialValues: {
      id: null,
      museum: userData?.museum,
      no_of_pieces: null,
      transit_objects: transitObjectsIds || [], // array

      current_location: transitSelectedDatas?.fromLocation?.value || "",
      selectedCurrentLocation: transitSelectedDatas?.fromLocation || "",
      new_location: transitSelectedDatas?.toLocation?.value || "",
      selectedNewLocation: transitSelectedDatas?.toLocation || "",
      no_of_pieces: transitSelectedDatas?.objectIds?.length || [],

      is_condition_good: false,
      is_condition_stable: false,
      is_condition_unstable: false,
      is_condition_emergency: false,

      artifacts_condition_notes: "",
      reason_of_movement: "",
      mode_of_movement: "",
      packaging_notes: "",

      is_artifacts_packed: false,
      is_artifacts_unpacked: false,

      start_of_transit: "", // date string (can be ISO string)
      received_by: null,
      selectedUser: null,
      selectedCollectionRepresentative: null,
      selectedConservationRepresentative: null,
      collection_representative: null,
      conservation_representative: null,
    },
    onSubmit: (values) => {
      setButtonLoader(true);
      if (id) {
        values.id = id;
      }
      creatTransit(values)((response) => {
        if (response?.status) {
          setButtonLoader(false);
          navigate(`/${commonPath}/${TRANSIT_FORM_LIST}`);
          toast.success(
            id
              ? "Transit form updated successfully"
              : "Transit form created successfully"
          );
        } else {
          setButtonLoader(false);
          toast.error(response?.message);
        }
      });
    },
  });

  const transitApproveSubmitHandler = () => {
    setButtonLoader(true);
    transitApprove({ id: id, reciver_remarks: receiverRemark })((response) => {
      if (response?.status) {
        setButtonLoader(false);
        if (fromNotification) {
          if (fromNotificationHeader) {
            navigate(-1);
          } else {
            navigate(`/${commonPath}/${lIST_NOTIFICATION}`);
          }
        } else if (fromDetail) {
          navigate(`/${commonPath}/${ADMIN_DETAILS}/${idFromDetail}`);
        } else if (fromTransitTable) {
          navigate(`/${commonPath}/${TRANSIT_FORM_LIST}`);
        } else {
          navigate(`/${commonPath}/${TRNSIT_OBJECT_LIST}`, {
            state: { fromTransitInner: true },
          });
        }
        toast.success("Transit form approved successfully");
      } else {
        setButtonLoader(false);
        toast.error(response?.message);
      }
    });
  };

  const withdrawHandler = () => {
    withdrawPdf({ id: id })((response) => {
      if (response?.status) {
        toast.success("Tranist form withdrawed successfully");
        navigate(`/${commonPath}/${TRANSIT_FORM_LIST}`);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const checkedPackedArtifactPacked = (checkedValue) => {
    formik?.setValues({
      ...formik?.values,
      is_artifacts_packed: checkedValue?.target?.checked,
    });
  };

  const checkedUnpackedArtifact = (checkedValue) => {
    formik?.setValues({
      ...formik?.values,
      is_artifacts_unpacked: checkedValue?.target?.checked,
    });
  };

  const userChangeHandler = (userValue) => {
    formik?.setValues({
      ...formik?.values,
      received_by: userValue?.value,
      selectedUser: userValue,
    });
  };

  const collectionRepresentativeChangeHandler = (userValue) => {
    formik?.setValues({
      ...formik?.values,
      collection_representative: userValue?.value,
      selectedCollectionRepresentative: userValue,
    });
  };

  const conservationRepresentativeChangeHandler = (userValue) => {
    formik?.setValues({
      ...formik?.values,
      conservation_representative: userValue?.value,
      selectedConservationRepresentative: userValue,
    });
  };

  const navigationBackHandler = () => {
    if (fromNotification) {
      if (fromNotificationHeader) {
        navigate(-1);
      } else {
        navigate(`/${commonPath}/${lIST_NOTIFICATION}`);
      }
    } else if (fromDetail) {
      navigate(`/${commonPath}/${ADMIN_DETAILS}/${idFromDetail}`);
    } else if (fromTransitTable) {
      navigate(`/${commonPath}/${TRANSIT_FORM_LIST}`);
    } else {
      navigate(`/${commonPath}/${TRNSIT_OBJECT_LIST}`, {
        state: { fromTransitInner: true },
      });
    }
  };

  const formattedCategories = (info = []) => {
    return Object.entries(
      info.reduce((acc, item) => {
        const primary = item?.current_prime_category_name;
        const sub = item?.current_sub_category_name;

        if (!primary && !sub) return acc;

        if (primary) {
          if (!acc[primary]) acc[primary] = new Set();
          if (sub) acc[primary].add(sub);
        } else if (sub) {
          if (!acc["_no_primary"]) acc["_no_primary"] = new Set();
          acc["_no_primary"].add(sub);
        }

        return acc;
      }, {})
    )
      .map(([primary, subs]) => {
        const subList = Array.from(subs);
        if (primary === "_no_primary") return subList.join(", ");
        if (subList.length > 0) return `${primary} - ${subList.join(", ")}`;
        return primary;
      })
      .join(", ");
  };

  const getConditionLabel = (obj) => {
    if (obj.is_condition_emergency) return "Emergency";
    if (obj.is_condition_good) return "Good";
    if (obj.is_condition_stable) return "Stable";
    if (obj.is_condition_unstable) return "Unstable";

    if (obj.is_emergency) return "Emergency";

    switch (obj.stability) {
      case 1:
        return "Good";
      case 2:
        return "Stable";
      case 3:
        return "Unstable";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (id) {
      setTransitLoading(true);
      singleTransitDetails({ page: 1, id: id })((response) => {
        if (response?.status) {
          setTransitLoading(false);
          const transitDetailData = response?.data;
          const transitObject = transitDetailData?.transit_objects;
          const transitObjectDetailIds = transitObject?.map((liObj) => ({
            id: liObj?.id,
            museum_object: liObj?.museum_object,
          }));
          const firstTransitObject = transitObject[0];
          if (transitDetailData?.reciver_remarks) {
            setRecieverRemark(transitDetailData?.reciver_remarks);
          }
          const transitObjectActiveData = transitObject?.map(
            (liobjec, indexOf) => {
              return {
                ...liobjec,
                is_swiper: indexOf === 0 ? true : false,
              };
            }
          );
          setBasicInformation(transitObjectActiveData);
          const categoryOrder =
            firstTransitObject?.current_sub_category_name &&
            firstTransitObject?.current_prime_category_name
              ? `${firstTransitObject?.current_prime_category_name}-${firstTransitObject?.current_sub_category_name}`
              : firstTransitObject?.current_prime_category_name ||
                firstTransitObject?.current_prime_category_name;

          let firststability = null;
          if (firstTransitObject?.is_condition_emergency) {
            firststability = "Emergency";
          } else if (firstTransitObject?.is_condition_good) {
            firststability = "Good";
          } else if (firstTransitObject?.is_condition_stable) {
            firststability = "Stable";
          } else if (firstTransitObject?.is_condition_unstable) {
            firststability = "Unstable";
          }

          setSelectedObject({
            name: firstTransitObject?.object_name,
            category: categoryOrder,
            location: firstTransitObject?.current_location_name,
            image: firstTransitObject?.reference_image,
            accession_number: firstTransitObject?.accession_number,
            stability: firststability,
          });

          setRecievedBy(transitDetailData?.received_by);
          setCreateBy(transitDetailData?.created_by);
          setFormStatus(transitDetailData?.form_status);

          formik?.setValues({
            ...formik?.values,
            no_of_pieces: transitDetailData?.no_of_pieces,
            transit_objects: transitObjectDetailIds,
            current_location: transitDetailData?.current_location,
            selectedCurrentLocation: {
              value: transitDetailData?.current_location,
              label: transitDetailData?.current_location_room_name,
              code: transitDetailData?.current_location_room_code,
            },
            new_location: transitDetailData?.new_location,
            selectedNewLocation: {
              value: transitDetailData?.new_location,
              label: transitDetailData?.new_location_room_name,
              code: transitDetailData?.new_location_room_code,
            },
            is_condition_good: transitDetailData?.is_condition_good,
            is_condition_stable: transitDetailData?.is_condition_stable,
            is_condition_unstable: transitDetailData?.is_condition_unstable,
            is_condition_emergency: transitDetailData?.is_condition_emergency,
            artifacts_condition_notes:
              transitDetailData?.artifacts_condition_notes,
            reason_of_movement: transitDetailData?.reason_of_movement,
            mode_of_movement: transitDetailData?.mode_of_movement,
            is_artifacts_packed: transitDetailData?.is_artifacts_packed,
            is_artifacts_unpacked: transitDetailData?.is_artifacts_unpacked,
            packaging_notes: transitDetailData?.packaging_notes,
            received_by: transitDetailData?.received_by,
            collection_representative:
              transitDetailData?.collection_representative,
            conservation_representative:
              transitDetailData?.conservation_representative,
            selectedCollectionRepresentative: {
              value: transitDetailData?.collection_representative,
              label: transitDetailData?.collection_representative_first_name,
            },
            selectedConservationRepresentative: {
              value: transitDetailData?.conservation_representative,
              label: transitDetailData?.conservation_representative_first_name,
            },
            selectedUser: {
              value: transitDetailData?.received_by,
              label: transitDetailData?.received_by_name,
            },
          });
        } else {
        }
      });
    }
  }, []);

  useEffect(() => {
    if (transitSelectedDatas) {
      setTransitLoading(true);

      getBasicInformation({ id: transitSelectedDatas?.objectIds })(
        (response) => {
          if (response?.status) {
            const transitObjectActiveDataBasic = response?.data?.map(
              (liobjec, indexOf) => {
                return {
                  ...liobjec,
                  is_swiper: indexOf === 0 ? true : false,
                };
              }
            );
            setBasicInformation(transitObjectActiveDataBasic);
            let updates = {};

            response.data.forEach((item) => {
              const stability = Number(item?.stability);

              if (stability === 1) updates.is_condition_good = true;
              if (stability === 2) updates.is_condition_stable = true;
              if (stability === 3) updates.is_condition_unstable = true;
              if (item.is_emergency === true)
                updates.is_condition_emergency = true;
            });
            const noOfPieces = response?.data?.reduce(
              (sum, item) => sum + (item.number_of_parts || 0),
              0
            );
            formik.setValues((prev) => ({
              ...prev,
              ...updates,
              no_of_pieces: noOfPieces,
            }));

            const firstData = response?.data[0];
            const categoryOrder =
              firstData?.current_sub_category_name &&
              firstData?.current_prime_category_name
                ? `${firstData?.current_prime_category_name}-${firstData?.current_sub_category_name}`
                : firstData?.current_prime_category_name ||
                  firstData?.current_prime_category_name;

            let firststabilityDetail = null;
            if (firstData?.is_emergency) {
              firststabilityDetail = "Emergency";
            } else if (firstData?.stability === 1) {
              firststabilityDetail = "Good";
            } else if (firstData?.stability === 2) {
              firststabilityDetail = "Stable";
            } else if (firstData?.stability === 3) {
              firststabilityDetail = "Unstable";
            }

            setSelectedObject({
              name: firstData?.object_name,
              accession_number: firstData?.accession_number,
              category: categoryOrder,
              location: firstData?.current_location_name,
              image: firstData?.reference_image,
              stability: firststabilityDetail,
            });

            setTransitLoading(false);
          } else {
            setTransitLoading(false);
          }
        }
      );
    }
  }, []);

  let typingTimeruser;
  const userLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimeruser);
      typingTimeruser = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            transit_approval: true,
          })((response) => {
            if (response?.status) {
              const isSameUser = response?.data?.filter(
                (li) => Number(li.value) !== Number(userData?.id)
              );

              setUser(isSameUser);
              resolve(isSameUser);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerCollectionRepresentative;
  const collectionRepresentativeLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerCollectionRepresentative);
      typingTimerCollectionRepresentative = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            transit_approval: true,
          })((response) => {
            if (response?.status) {
              setCollectionRepresentative(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerConservationRepresentative;
  const conservationRepresentativeLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerConservationRepresentative);
      typingTimerConservationRepresentative = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            transit_approval: true,
          })((response) => {
            if (response?.status) {
              setConservationRepresentative(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  useEffect(() => {
    setUserLoading(true);
    listUserDropdown({ museum_id: userData?.museum, transit_approval: true })(
      (response) => {
        if (response?.status) {
          const isSameUser = response?.data?.filter(
            (li) => Number(li.value) !== Number(userData?.id)
          );

          setUser(isSameUser);
          setDefaultUser(isSameUser);
          setUserLoading(false);
        } else {
          setUserLoading(false);
        }
      }
    );
  }, []);

  useEffect(() => {
    setCollectionRepresentativeLoading(true);
    listUserDropdown({ museum_id: userData?.museum, transit_approval: true })(
      (response) => {
        if (response?.status) {
          setCollectionRepresentative(response?.data);
          setDefaultCollectionRepresantative(response?.data);
          setCollectionRepresentativeLoading(false);
        }
      }
    );
  }, []);

  useEffect(() => {
    setConservationRepresentativeLoading(true);
    listUserDropdown({ museum_id: userData?.museum, transit_approval: true })(
      (response) => {
        if (response?.status) {
          setConservationRepresentative(response?.data);
          setDefaultConservationRepresentative(response?.data);
          setConservationRepresentativeLoading(false);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (newValue === "") {
      setUser(defaultUser);
      setCollectionRepresentative(defaultCollectionRepresantative);
      setConservationRepresentative(defaultConservationRepresentative);
    }
  }, [newValue, user, collectionRepresentative, conservationRepresentative]);

  return (
    <section
      style={{ paddingTop: "50px" }}
      className="dashboard appraisal-management light-wrapper dark-wrapper"
    >
      <Container>
        {showImageEnlarge?.show && (
          <ImageEnlarge
            imageData={showImageEnlarge}
            setShowReference={setShowEnlargeImage}
          />
        )}
        {transitLoading ? (
          <Loader />
        ) : (
          <>
            <div
              style={{ marginTop: "50px" }}
              className="add-category-title-row"
            >
              {buttonLoader && <div className="loader-overlay" />}
              <div className=" title-row-content">
                <div className="title-icon " onClick={navigationBackHandler}>
                  <GoArrowLeft />
                </div>
                <h4 style={{ fontWeight: "600" }}> Transit&nbsp;&nbsp;form</h4>
              </div>
            </div>
            <Form onSubmit={formik?.handleSubmit}>
              <Row>
                <Col lg={8}>
                  <div className="transit-form-inner-content-container">
                    <div className="accesion-number-and-object">
                      <Form.Label>Accession number</Form.Label>
                      <div className="accession-title-two">
                        <span>{`(old/new accession number(s), new location and material specification accession numbers)`}</span>
                        <div className="number-of-pieces">
                          <span>{`No. of objects :${basicInformation?.length}`}</span>
                          {/* <div className="number-of-piece-delete">
                            <RiDeleteBin6Line />
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div
                      className="object-accession-list"
                      style={{ marginBottom: "1.5rem" }}
                    >
                      {basicInformation?.map((liBasic, basicIndex) => (
                        <div
                          onClick={() => {
                            const categoryOrder =
                              liBasic?.current_sub_category_name &&
                              liBasic?.current_prime_category_name
                                ? `${liBasic?.current_prime_category_name}-${liBasic?.current_sub_category_name}`
                                : liBasic?.current_prime_category_name ||
                                  liBasic?.current_prime_category_name;
                            let firstSelected = null;

                            if (transitSelectedDatas) {
                              if (liBasic?.is_emergency) {
                                firstSelected = "Emergency";
                              } else if (liBasic?.stability === 1) {
                                firstSelected = "Good";
                              } else if (liBasic?.stability === 2) {
                                firstSelected = "Stable";
                              } else if (liBasic?.stability === 3) {
                                firstSelected = "Unstable";
                              }
                            } else {
                              if (liBasic?.is_condition_emergency) {
                                firstSelected = "Emergency";
                              } else if (liBasic?.is_condition_good) {
                                firstSelected = "Good";
                              } else if (liBasic?.is_condition_stable) {
                                firstSelected = "Stable";
                              } else if (liBasic?.is_condition_unstable) {
                                firstSelected = "Unstable";
                              }
                            }

                            setSelectedObject({
                              image: liBasic?.reference_image,
                              category: categoryOrder,
                              location: liBasic?.current_location_name,
                              name: liBasic?.object_name,
                              accession_number: liBasic?.accession_number,
                              stability: firstSelected,
                            });
                            if (swiperRef.current) {
                              swiperRef.current.slideTo(basicIndex);
                            }
                          }}
                          style={{
                            border: liBasic?.is_swiper
                              ? "2px solid #3983f8"
                              : "2px solid #d4e8fa",
                          }}
                          className="object-accession-option"
                        >
                          {liBasic?.accession_number}
                        </div>
                      ))}
                    </div>
                    <div
                      style={{ marginBottom: "1.5rem" }}
                      className="no-of-pieces"
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <Form.Label>No of pieces</Form.Label>
                        {"  "}:{"  "}
                        <p>{formik?.values?.no_of_pieces}</p>
                      </div>
                    </div>
                    <div
                      className="category-artifact-transit"
                      style={{ marginBottom: "1.5rem" }}
                    >
                      <Form.Label>Category of the artefacts</Form.Label>
                      <div className="category-transit-box">
                        <p>{formattedCategories(basicInformation)}</p>
                      </div>
                    </div>
                    <div
                      className="location-transit"
                      style={{ marginBottom: "1.5rem" }}
                    >
                      <Form.Label>Location</Form.Label>
                      <div className="location-select-container">
                        <div className="current-location">
                          <p className="option-title">
                            {`Current location (from)`}{" "}
                          </p>
                          <div className="location-form-container">
                            <p
                              style={{ width: "70px" }}
                              className="option-title"
                            >
                              Room no
                            </p>
                            <div className="room-code-container">
                              <p>{`${formik?.values?.selectedCurrentLocation?.label}`}</p>
                              <p>
                                {" "}
                                {`(${formik?.values?.selectedCurrentLocation?.code})`}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="storage-location">
                          <p className="option-title">
                            {`Storage location (to)`}{" "}
                          </p>
                          <div className="location-form-container">
                            <p
                              style={{ width: "70px" }}
                              className="option-title"
                            >
                              Room no
                            </p>
                            <div className="room-code-container">
                              <p>
                                {`${formik?.values?.selectedNewLocation.label}`}{" "}
                              </p>
                              <p>{`(${formik?.values?.selectedNewLocation.code})`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="condition-transit"
                      style={{ marginBottom: "1.5rem" }}
                    >
                      <Form.Label>Condition of artefact</Form.Label>
                      <div className="condition-option-container">
                        <div className="condition-options">
                          <Form.Label className="option-title">Good</Form.Label>
                          <Form.Check
                            checked={formik?.values?.is_condition_good}
                            style={{ opacity: 1, pointerEvents: "none" }}
                          />
                        </div>
                        <div className="condition-options">
                          <Form.Label className="option-title" l>
                            Stable
                          </Form.Label>
                          <Form.Check
                            checked={formik?.values?.is_condition_stable}
                            style={{ opacity: 1, pointerEvents: "none" }}
                          />
                        </div>
                        <div className="condition-options">
                          <Form.Label className="option-title">
                            Unstable
                          </Form.Label>
                          <Form.Check
                            checked={formik?.values?.is_condition_unstable}
                            style={{ opacity: 1, pointerEvents: "none" }}
                          />
                        </div>
                        <div className="condition-options">
                          <Form.Label className="option-title">
                            Emergency
                          </Form.Label>
                          <Form.Check
                            checked={formik?.values?.is_condition_emergency}
                            style={{ opacity: 1, pointerEvents: "none" }}
                          />
                        </div>
                      </div>
                      <div className="condition-notes">
                        <Form.Control
                          rows={5}
                          cols={2}
                          value={formik?.values?.artifacts_condition_notes}
                          onChange={formik?.handleChange}
                          maxLength={2000}
                          name="artifacts_condition_notes"
                          placeholder="Notes (if any)...."
                          as={"textarea"}
                          disabled={fromNotification || fromDetail || fromview}
                        />
                        <Form.Text className="text-muted">
                          {`Maximum character ${
                            formik?.values?.artifacts_condition_notes?.length ||
                            0
                          }/2000`}
                        </Form.Text>
                      </div>
                    </div>
                    <div
                      className="transit-reason"
                      style={{ marginBottom: "1.5rem" }}
                    >
                      <Form.Label>Reason of movement</Form.Label>
                      <div className="transit-reason-conrol-field">
                        <Form.Control
                          rows={5}
                          cols={2}
                          disabled={fromNotification || fromDetail || fromview}
                          value={formik?.values?.reason_of_movement}
                          onChange={formik?.handleChange}
                          placeholder="Reason of movement"
                          name="reason_of_movement"
                          as={"textarea"}
                          maxLength={2000}
                        />
                        <Form.Text className="text-muted">
                          {`Maximum character ${
                            formik?.values?.reason_of_movement?.length || 0
                          }/2000`}
                        </Form.Text>
                      </div>
                    </div>
                    <Form.Group className="mb-4 ">
                      <Form.Label>Modes of Movement</Form.Label>
                      <Form.Text
                        className="d-block mb-2 "
                        style={{ color: "#adadad", marginTop: "-9px" }}
                      >
                        {`( Number of people involved, number of days/hours taken,
                        type of machinery used, with or without storage)`}
                      </Form.Text>
                      <Form.Control
                        disabled={
                          fromNotification || fromDetail || fromview || fromview
                        }
                        value={formik?.values?.mode_of_movement}
                        onChange={formik?.handleChange}
                        name="mode_of_movement"
                        as="textarea"
                        rows={4}
                        maxLength={2000}
                        placeholder="Enter details..."
                      />
                      <Form.Text className="text-muted">
                        {`Maximum character ${
                          formik?.values?.mode_of_movement?.length || 0
                        }/2000`}
                      </Form.Text>
                    </Form.Group>

                    {/* Packaging */}
                    <Form.Group className="mb-4">
                      <Form.Label>Packaging</Form.Label>
                      <div className="d-flex gap-3 mb-2">
                        <Form.Check
                          disabled={fromNotification || fromDetail || fromview}
                          onChange={checkedPackedArtifactPacked}
                          checked={formik?.values?.is_artifacts_packed}
                          type="checkbox"
                          label="Packed"
                        />
                        <Form.Check
                          disabled={fromNotification || fromDetail || fromview}
                          onChange={checkedUnpackedArtifact}
                          checked={formik?.values?.is_artifacts_unpacked}
                          type="checkbox"
                          label="Unpacked"
                        />
                      </div>
                      <Form.Control
                        disabled={fromNotification || fromDetail || fromview}
                        as="textarea"
                        rows={3}
                        maxLength={2000}
                        placeholder="Notes (if any)..."
                        value={formik?.values?.packaging_notes}
                        onChange={formik?.handleChange}
                        name="packaging_notes"
                      />
                      <Form.Text className="text-muted">
                        {`Maximum character ${
                          formik?.values?.packaging_notes?.length || 0
                        }/2000`}
                      </Form.Text>
                    </Form.Group>

                    {/* Receive Person */}
                    <Form.Group className="mb-4">
                      <Form.Label>Receive person</Form.Label>
                      <span className="required">
                        <sup>*</sup>
                      </span>
                      <AsyncSelect
                        isDisabled={fromNotification || fromDetail || fromview}
                        placeholder="Receive person"
                        loadOptions={userLoadOptionHandler}
                        onChange={userChangeHandler}
                        defaultOptions={user}
                        noOptionsMessage={() =>
                          userLoading ? "Loading..." : "No options"
                        }
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: "400px",
                            backgroundColor: state.isDisabled
                              ? "#e9ecf0"
                              : "white",
                            border: state.isFocused
                              ? "1px solid #86b7fe"
                              : formik?.errors?.received_by &&
                                formik?.touched?.received_by
                              ? "1px solid #dc3545"
                              : "1px solid #EEEEEE",
                            boxShadow: "none",
                            "&:hover": {
                              border: state.isFocused
                                ? "1px solid #86b7fe"
                                : "1px solid #EEEEEE",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "400px",
                            marginBottom: "12px", // 👈 adds space below the dropdown
                            zIndex: 10, // ensure it’s above other elements
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            paddingBottom: "8px", // space inside the list
                          }),
                        }}
                        value={formik?.values?.selectedUser}
                        onInputChange={(newValue, { action }) => {
                          if (action === "input-change" && newValue === "") {
                            setUser(defaultUser);
                          }
                        }}
                      />
                      {formik.errors.received_by &&
                        formik?.touched?.received_by && (
                          <span className="text-danger">
                            {formik?.errors?.received_by}
                          </span>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label>Collection representative</Form.Label>
                      <span className="required">
                        <sup>*</sup>
                      </span>
                      <AsyncSelect
                        isDisabled={fromNotification || fromDetail || fromview}
                        placeholder="Collection representative"
                        loadOptions={collectionRepresentativeLoadOptionHandler}
                        onChange={collectionRepresentativeChangeHandler}
                        defaultOptions={collectionRepresentative}
                        noOptionsMessage={() =>
                          collectionRepresentativeLoading
                            ? "Loading..."
                            : "No options"
                        }
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: "400px",
                            backgroundColor: state.isDisabled
                              ? "#e9ecf0"
                              : "white",
                            border: state.isFocused
                              ? "1px solid #86b7fe"
                              : formik?.errors?.collection_representative &&
                                formik?.touched?.collection_representative
                              ? "1px solid #dc3545"
                              : "1px solid #EEEEEE",
                            boxShadow: "none",
                            "&:hover": {
                              border: state.isFocused
                                ? "1px solid #86b7fe"
                                : "1px solid #EEEEEE",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "400px",
                            marginBottom: "12px", // 👈 adds space below the dropdown
                            zIndex: 10, // ensure it’s above other elements
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            paddingBottom: "8px", // space inside the list
                          }),
                        }}
                        value={formik?.values?.selectedCollectionRepresentative}
                        onInputChange={(newValue, { action }) => {
                          if (action === "input-change" && newValue === "") {
                            setCollectionRepresentative(
                              defaultCollectionRepresantative
                            );
                          }
                        }}
                      />
                      {formik.errors.collection_representative &&
                        formik?.touched?.collection_representative && (
                          <span className="text-danger">
                            {formik?.errors?.collection_representative}
                          </span>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label>Conservation representative</Form.Label>
                      <span className="required">
                        <sup>*</sup>
                      </span>
                      <AsyncSelect
                        isDisabled={fromNotification || fromDetail || fromview}
                        placeholder="Conservation representative remark"
                        loadOptions={
                          conservationRepresentativeLoadOptionHandler
                        }
                        onChange={conservationRepresentativeChangeHandler}
                        defaultOptions={conservationRepresentative}
                        noOptionsMessage={() =>
                          conservationRepresentativeLoading
                            ? "Loading..."
                            : "No options"
                        }
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: "400px",
                            backgroundColor: state.isDisabled
                              ? "#e9ecf0"
                              : "white",
                            border: state.isFocused
                              ? "1px solid #86b7fe"
                              : formik?.errors?.conservation_representative &&
                                formik?.touched?.conservation_representative
                              ? "1px solid #dc3545"
                              : "1px solid #EEEEEE",
                            boxShadow: "none",
                            "&:hover": {
                              border: state.isFocused
                                ? "1px solid #86b7fe"
                                : "1px solid #EEEEEE",
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "400px",
                            marginBottom: "12px", // 👈 adds space below the dropdown
                            zIndex: 10, // ensure it’s above other elements
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                            paddingBottom: "8px", // space inside the list
                          }),
                        }}
                        value={
                          formik?.values?.selectedConservationRepresentative
                        }
                        onInputChange={(newValue, { action }) => {
                          setNewValue(newValue);
                          if (action === "input-change" && newValue === "") {
                            setConservationRepresentative(
                              defaultConservationRepresentative
                            );
                          }
                        }}
                      />
                      {formik.errors.conservation_representative &&
                        formik?.touched?.conservation_representative && (
                          <span className="text-danger">
                            {formik?.errors?.conservation_representative}
                          </span>
                        )}
                    </Form.Group>
                    {/* Receiver Remarks */}

                    {formStatus === "Approved" ? (
                      <Form.Group className="mb-4">
                        <Form.Label>Receiver remarks</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          maxLength={2000}
                          disabled={true}
                          placeholder="Enter remarks..."
                          isInvalid={recieverValidation}
                          value={receiverRemark}
                          onChange={(e) => {
                            if (recieverValidation && e.target.value) {
                              setRecieverValidation(false);
                            }
                            setRecieverRemark(e.target.value);
                          }}
                          name="received_by"
                        />
                      </Form.Group>
                    ) : recievedBy === userData?.id &&
                      formStatus === "Pending" ? (
                      <Form.Group className="mb-4">
                        <Form.Label>Receiver remarks</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          maxLength={2000}
                          placeholder="Enter remarks..."
                          isInvalid={recieverValidation}
                          value={receiverRemark}
                          onChange={(e) => {
                            if (recieverValidation && e.target.value) {
                              setRecieverValidation(false);
                            }
                            setRecieverRemark(e.target.value);
                          }}
                          name="received_by"
                        />
                      </Form.Group>
                    ) : null}
                  </div>
                  {formStatus === "Approved" || formStatus === "Withdrawn" ? (
                    <></>
                  ) : (
                    createBy === userData?.id && (
                      <div className="submit-btn-row">
                        <Button
                          className="submit-btn"
                          onClick={withdrawHandler}
                          type="button"
                        >
                          Withdraw
                        </Button>
                      </div>
                    )
                  )}

                  {formStatus === "Approved" || formStatus === "Withdrawn" ? (
                    <></>
                  ) : (
                    recievedBy === userData?.id && (
                      <div className="submit-btn-row">
                        <Button
                          className="submit-btn"
                          onClick={transitApproveSubmitHandler}
                          type="button"
                        >
                          Approve
                        </Button>
                      </div>
                    )
                  )}

                  {formStatus === "Approved" || formStatus === "Withdrawn" ? (
                    <div className="submit-btn-row">
                      <Button
                        style={{
                          cursor: "default",
                          backgroundColor: "#20409A",
                          border: "1px solid",
                        }}
                        type="button"
                      >
                        {formStatus}
                      </Button>
                    </div>
                  ) : (
                    (!recievedBy === userData?.id ||
                      !createBy === userData?.id) && (
                      <div className="submit-btn-row">
                        <Button
                          style={{
                            cursor: "default",
                            backgroundColor: "#20409A",
                            border: "1px solid",
                          }}
                          type="button"
                        >
                          {formStatus}
                        </Button>
                      </div>
                    )
                  )}

                  {!id && (
                    <div className="submit-btn-row">
                      <Button
                        className="discard-btn"
                        onClick={() => {
                          navigate(`/${commonPath}/${TRANSIT_FORM_LIST}`);
                        }}
                        type="button"
                      >
                        Discard changes
                      </Button>
                      <Button className="submit-btn" type="submit">
                        Create
                      </Button>
                    </div>
                  )}
                </Col>
                <Col lg={4}>
                  <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    spaceBetween={10}
                    slidesPerView={1}
                    className="object-swiper-transit"
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    onSlideChange={(seiper) => {
                      const currentIndex = seiper.activeIndex;
                      const currentData = basicInformation[currentIndex];
                      setActiveSlide(currentData);
                      setBasicInformation((prev) =>
                        prev.map((li) => ({
                          ...li,
                          is_swiper: li.id === currentData?.id, // true for selected, false for others
                        }))
                      );
                    }}
                  >
                    {basicInformation?.map((obj, index) => (
                      <SwiperSlide key={index}>
                        <div className="object-detail-box-container">
                          <div className="object-card">
                            <div className="object-card-image-container">
                              <div
                                className="object-card__left"
                                style={{ width: "100%" }}
                              >
                                <div className="object-card__main-image">
                                  <img
                                    style={{ cursor: "pointer" }}
                                    src={obj.reference_image}
                                    alt="Object"
                                    onClick={() => {
                                      setShowEnlargeImage({
                                        image: obj.reference_image,
                                        title: "Reference image",
                                        show: true,
                                        isEdit: false,
                                      });
                                    }}
                                  />
                                  <div
                                    class={
                                      obj.is_swiper
                                        ? "accession-wrapper-active"
                                        : "accession-wrapper"
                                    }
                                  >
                                    <span className="object-card__tag">
                                      {obj.accession_number}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="object-card__details">
                              <div style={{ display: "flex", gap: "10px" }}>
                                {obj.object_name && (
                                  <div className="object-card__field">
                                    <label>Object name</label>
                                    <span>{obj.object_name}</span>
                                  </div>
                                )}
                                <div className="object-card__field">
                                  <label>Condition</label>
                                  <span>{getConditionLabel(obj)}</span>
                                </div>
                              </div>

                              {(obj.current_prime_category_name ||
                                obj.current_sub_category_name) && (
                                <div
                                  style={{ width: "fit-content" }}
                                  className="object-card__field"
                                >
                                  <label>Category</label>
                                  <span>{`${obj.current_prime_category_name} - ${obj.current_sub_category_name}`}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </Form>
          </>
        )}
      </Container>
    </section>
  );
};

export default Transitforminner;
